export default class MatchStatus {
  public type: string = null;
  public subType: string = null;
}
